import React, { useEffect } from 'react'
import {
    AllEvents,
    createEditionViewItemListEvent,
    Features,
} from '@news-mono/web-common'
import { SpecialEditionItem } from './components/EditionItem'
import {
    StyledEditionsPage,
    StyledEditionsSection,
    StyledEditionsHeading,
    StyledOnEditionList,
} from './PreviousSpecialEditions.styled'

export type EditionConfig = {
    title: string
    heading: string
    teaser: string
    link: string
    imageURL: string
    socialImageURL: string
    lazyloadImages: boolean
    featureToggle: Features
    alt: string
    publicationDate: string
    curation: string
    path: string
    id?: string
} // this is from /news-mono/apps/thenightly/src/app/routes/thenightly-on/onEditionsConfig.ts , but not importing as this config will be removed in the future

export interface NightlyPreviousSpecialEditionsProps {
    title?: string
    editions: EditionConfig[]
    onEvent: (event: AllEvents) => void
}

export const NightlyPreviousSpecialEditions: React.FC<NightlyPreviousSpecialEditionsProps> =
    ({ editions, title = 'Latest Nightly On Editions', onEvent }) => {
        useEffect(() => {
            const event = createEditionViewItemListEvent({
                editions: editions,
                collectionName: 'thenightly_on_home_page',
                itemCategory: 'latest_nightly_on_editions_page', // before change, will need to add to valid type first
            })
            event && onEvent(event)
        }, [editions, onEvent])

        return (
            <StyledEditionsPage>
                <StyledEditionsSection>
                    <StyledEditionsHeading>
                        {editions.length > 0 && <h2>{title}</h2>}
                    </StyledEditionsHeading>

                    <StyledOnEditionList>
                        {editions.map((edition, index) => (
                            <SpecialEditionItem
                                edition={edition}
                                onEvent={onEvent}
                                key={index}
                            />
                        ))}
                    </StyledOnEditionList>
                </StyledEditionsSection>
            </StyledEditionsPage>
        )
    }
